import { BUSINESS_INCOME_TYPES } from "@/constants/businessIncomes";
import { z } from "zod";

export const createBusinessIncomeSchema = z.object({
  organization_id: z.string().min(1, "Debe seleccionar una organización"),
  property_id: z.string().optional(),
  income_type: z.enum([...BUSINESS_INCOME_TYPES] as [string, ...string[]]),
  payment_type: z.enum(["Efectivo", "Transferencia", "Deducción"]),
  gross_payment: z.number().optional(),
  iva: z.number().optional(),
  total_payment: z.number().min(0.01, "El pago total debe ser mayor a 0").optional().nullable(),
  payment_status: z.enum(["Pendiente", "Pagado", "Cancelado"]),
  description: z.string().optional(),
  payment_date: z.date().optional().nullable(),
}).refine((data) => data.total_payment != null && data.total_payment >= 0.01, {
  message: "El pago total debe ser mayor a 0",
  path: ["total_payment"],
});

export type CreateBusinessIncomeData = z.infer<
  typeof createBusinessIncomeSchema
>;
